var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileuploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3229 1.33203H4.98958C4.25625 1.33203 3.66292 1.93203 3.66292 2.66536L3.65625 13.332C3.65625 14.0654 4.24958 14.6654 4.98292 14.6654H12.9896C13.7229 14.6654 14.3229 14.0654 14.3229 13.332V5.33203L10.3229 1.33203ZM11.6562 11.9987H6.32292V10.6654H11.6562V11.9987ZM11.6562 9.33203H6.32292V7.9987H11.6562V9.33203ZM9.65625 5.9987V2.33203L13.3229 5.9987H9.65625Z",
    fill: "#6F7494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileuploadIcon);
export default __webpack_public_path__ + "static/media/fileupload-icon.3c0d2c437744c6bb9d4559959b3d7537.svg";
export { ForwardRef as ReactComponent };